// RC4 Part 2 · ITEM 9 — shared tour display label helper (frontend).
// Mirrors backend/services/tour_display.py priority order EXACTLY:
//   1. tour_name / display_name (non-empty, non-whitespace)
//   2. client display_name (customer.display_name / customer_name)
//   3. "Unnamed Tour"
// NEVER returns tour_number, tour.id, or any raw UUID.

const UNNAMED = "Unnamed Tour";

function _clean(v) {
  if (v == null) return null;
  const s = String(v).trim();
  return s.length ? s : null;
}

export function tourDisplayLabel(tour, opts = {}) {
  const { clientName = null } = opts;
  if (!tour || typeof tour !== "object") {
    return _clean(clientName) || UNNAMED;
  }
  const name = _clean(tour.tour_name) || _clean(tour.display_name);
  if (name) return name;
  const c = _clean(clientName)
    || _clean(tour.customer_display_name)
    || _clean(tour.customer_name)
    || _clean(tour.customer?.display_name);
  if (c) return c;
  return UNNAMED;
}

export default tourDisplayLabel;
